import { render, staticRenderFns } from "./entrubanfrom.vue?vue&type=template&id=728ac438&"
import script from "./entrubanfrom.vue?vue&type=script&lang=js&"
export * from "./entrubanfrom.vue?vue&type=script&lang=js&"
import style0 from "./entrubanfrom.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports